import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import CustomEmailTemplate from "../../services/Api/templateApi";

export const addCustomTemplate = createAsyncThunk(
  "templete/addTemplate",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await CustomEmailTemplate.CustomEmailTemplate(payload);
      // data.seo_registration should already be an array
      return data;
    } catch (err) {
      /* prefer the most specific message, but ALWAYS make it a string */
      const message =
        err?.response?.data?.detail ||
        err?.response?.data?.message ||
        err.message ||
        "Something went wrong";
      return rejectWithValue(message);
    }
  }
);
export const getCustomTemplate = createAsyncThunk(
  "templete/getTemplate",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await CustomEmailTemplate.getCustomEmailTemplate();
      // data.seo_registration should already be an array
      return data;
    } catch (err) {
      /* prefer the most specific message, but ALWAYS make it a string */
      const message =
        err?.response?.data?.detail ||
        err?.response?.data?.message ||
        err.message ||
        "Something went wrong";
      return rejectWithValue(message);
    }
  }
);
export const editCustomTemplate = createAsyncThunk(
  "templete/editTemplate",
  async ({ payload, customTemplateId }, { rejectWithValue }) => {
    try {
      const { data } = await CustomEmailTemplate.editCustomEmailTemplate(
        payload,
        customTemplateId
      );
      // data.seo_registration should already be an array
      return data;
    } catch (err) {
      /* prefer the most specific message, but ALWAYS make it a string */
      const message =
        err?.response?.data?.detail ||
        err?.response?.data?.message ||
        err.message ||
        "Something went wrong";
      return rejectWithValue(message);
    }
  }
);

const customTemplateSlice = createSlice({
  name: "templateSlice",
  initialState: {
    items: [],
    status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addCustomTemplate.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addCustomTemplate.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.items = action.payload;
      })
      .addCase(addCustomTemplate.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(getCustomTemplate.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getCustomTemplate.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.items = action.payload;
      })
      .addCase(getCustomTemplate.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(editCustomTemplate.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(editCustomTemplate.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.items = action.payload;
      })
      .addCase(editCustomTemplate.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default customTemplateSlice.reducer;
